module.exports = __webpack_public_path__ + "static/media/sitemap_v_3_spanish.6d88693b.svg";